/**
 * Whether a search query names a package label rather than one of its markers:
 * the query starts the label or one of its words ("omega", "omega-3" →
 * "Omega-3 & 6"). Accent- and case-insensitive. No Fuse, so the explorer can
 * import it on its hot path.
 */
function normalize(s: string): string {
  return s.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim()
}

export function queryNamesLabel(query: string, label: string): boolean {
  const q = normalize(query)
  const l = normalize(label)
  return q.length > 0 && (l.startsWith(q) || l.includes(` ${q}`))
}
